export const SUPPORTED_FILE_TYPES = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.mp4',
  '.mp3',
  '.apk',
  '.xlsx',
  '.json',
];
